import api from "@/utils/backend-api";
import { Worker } from "@/models";
import {
  sendSuccessNotice,
  sendErrorNotice,
  closeNotice,
  getDefaultPagination,
  commitPagination,
} from "@/utils/store-util.js";

import { get } from "lodash";

const state = {
  workers: [],
  extWorkers: [],
  extWorkersAccCount: '',
  pagination: {},
  loading: true,
  notice: "",
};

const getters = {};

const actions = {
  getWorkers ({ commit }) {
    api.getData("workers/get-all").then(res => {
      if (res.data) {
        commit("setWorkers", res.data);
      }
    });
  },
  getExtWorkers ({ commit }) {
    api.getData("ext-workers").then(res => {
      if (res.data) {
        commit("setExtWorkers", res.data);
      }
    });
  },
  getWorkerById ({ commit }, id) {
    commit("setLoading", { loading: true });
    if (id) {
      api.getData("workers/get/" + id).then(
        res => {
          const worker = res.data;
          commit("setWorker", { worker });
          commit("setLoading", { loading: false });
        },
        err => {
          console.log(err);
        }
      );
    }
  },
  deleteWorker ({ commit, dispatch }, id) {
    api
      .deleteData("workers?id=" + id.toString())
      .then(res => {
        if (res.data.result === 'ok'){
          sendSuccessNotice(commit, res.data.message);
        } else {
          sendErrorNotice(commit, res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
        sendErrorNotice(commit, "Operation failed! Please try again later. ");
        closeNotice(commit, 1500);
      });
  },
  deleteExtWorker ({ commit, dispatch }, id) {
    api
      .deleteData("ext-workers?id=" + id.toString())
      .then(res => {
        if (res.data.result === 'ok'){
          sendSuccessNotice(commit, res.data.message);
        } else {
          sendErrorNotice(commit, res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
        sendErrorNotice(commit, "Operation failed! Please try again later. ");
        closeNotice(commit, 1500);
      });
  },
  subscribeWorker ({ commit, dispatch }, id) {
    api
      .postData("workers/subscribe?id=" + id.toString())
      .then(res => {
        if (res.data.result === 'ok'){
          sendSuccessNotice(commit, res.data.message);
        } else {
          sendErrorNotice(commit, res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
        sendErrorNotice(commit, "Operation failed! Please try again later. ");
        closeNotice(commit, 1500);
      });
  },
  addWorker ({ commit, dispatch }, nickname) {
    api
      .postData("workers/subscribe?nickname=" + nickname.toString())
      .then(res => {
        if (res.data.result === 'ok'){
          sendSuccessNotice(commit, res.data.message);
        } else {
          sendErrorNotice(commit, res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
        sendErrorNotice(commit, "Operation failed! Please try again later. ");
        closeNotice(commit, 1500);
      });
  },
  addExtWorker ({ commit, dispatch }) {
    api
      .postData("ext-workers/add")
      .then(res => {
        if (res.data.result === 'ok'){
          sendSuccessNotice(commit, res.data.message);
        } else {
          sendErrorNotice(commit, res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
        sendErrorNotice(commit, "Operation failed! Please try again later. ");
        closeNotice(commit, 1500);
      });
  },
  changeInput ({ state, commit, dispatch }, param) {
    api.postData("ext-workers/set-nick/" + param.id.toString() + "?field=" + param.field + "&value=" + param.value).then(res => {
//        return new Promise((resolve, reject) => {
//          api.getData("orders?" + param.query).then(res => {
//            refreshOrders(commit, res.data);
//          });
//          sendSuccessNotice(commit, "Operation is done.");
//        });
      })
      .catch(err => {
          console.log(err);
          sendErrorNotice(commit, "Operation failed! Please try again later. ");
          closeNotice(commit, 1500);
      });
  },
};

const mutations = {
  setWorkers (state, workers) {
    state.workers = workers;
  },
  setExtWorkers (state, extWorkers) {
    state.extWorkers = extWorkers.accounts;
    state.extWorkersAccCount = extWorkers.acc_count;
  },
  setWorker (state, { worker }) {
    state.worker = worker;
  },
  setPagination (state, pagination) {
    state.pagination = pagination;
  },
  setLoading (state, { loading }) {
    state.loading = loading;
  },
  setNotice (state, { notice }) {
    console.log(" notice .... ", notice);
    state.notice = notice;
  },
  setMode (state, {mode}) {
    state.mode = mode
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/workers.js